// removed by extract-text-webpack-plugin
module.exports = {"iframe":"src-display-modules-Home-Workbench2-UI-AppContainer-index__iframe--25i6g"};


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/Workbench2/UI.AppContainer/index.scss
// module id = 6673
// module chunks = 0